import React from "react";
import { Asterisk } from "lucide-react";

export default function Marquee({ site }) {
    const items = [
        "Beautiful Lawns",
        "All 4 Seasons",
        "Clean Cuts",
        "Healthy Lawns",
        "Year Round",
        site.business_name || "Alabama 4 Seasons",
    ];
    // Repeat enough content to make seamless loop
    const line = [...items, ...items];

    return (
        <section
            data-testid="marquee-section"
            className="relative border-y border-white/10 bg-lime-signal text-ink-900 overflow-hidden"
        >
            <div className="marquee-track animate-marquee py-6 md:py-8">
                {line.concat(line).map((word, i) => (
                    <span key={i} className="inline-flex items-center gap-8 md:gap-12 px-6 md:px-10 font-display uppercase text-4xl md:text-6xl leading-none tracking-tight">
                        {word}
                        <Asterisk className="w-6 h-6 md:w-8 md:h-8 opacity-80" />
                    </span>
                ))}
            </div>
        </section>
    );
}
